import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  //  ###    ###  ##   ##
  //  ## #  # ##  ##   ##
  //  ##  ##  ##  ##   ##
  //  ##      ##   ## ##
  //  ##      ##    ###

  if (document.getElementById('topMv')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars

    const sliderName = 'topMv'
    const slideItem = document.getElementById(sliderName)

    const topMvSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（topMvSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },
      autoplay: {
        // オートオプション
        delay: 2000, // 待機時間
        disableOnInteraction: false, // 操作されたら停止する
        // pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
        // stopOnLastSlide: true, // 最終スライドに到達したら停止する
      },
    })
  }

  //  ##   ##  ##  ####    #####   #####
  //  ##   ##  ##  ##  ##  ##     ##   ##
  //  ##   ##  ##  ##  ##  #####  ##   ##
  //   ## ##   ##  ##  ##  ##     ##   ##
  //    ###    ##  ####    #####   #####

  const video = document.getElementById('topVideo')

  const videoPlay = document.getElementById('topVideo-play')

  videoPlay.addEventListener('click', function (e) {
    video.play()

    video.setAttribute('controls', 'controls') // UIを設定

    e.target.parentNode.removeChild(e.target)
  })

  //  ###    ###  #####  ###    ###  #####   #####  #####
  //  ## #  # ##  ##     ## #  # ##  ##  ##  ##     ##  ##
  //  ##  ##  ##  #####  ##  ##  ##  #####   #####  #####
  //  ##      ##  ##     ##      ##  ##  ##  ##     ##  ##
  //  ##      ##  #####  ##      ##  #####   #####  ##   ##

  const memberSlide = new Swiper('#topMemberSlide', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
    },
  })
}
